import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "./index";

export interface UserState {
  username: string | null;
  email: string | null;
}

export type UserPayload = Partial<UserState>;

const initialState: UserState = {
  username: null,
  email: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<UserPayload>) {
      if (action.payload.username !== undefined) {
        state.username = action.payload.username;
      }
      if (action.payload.email !== undefined) {
        state.email = action.payload.email;
      }
    },
    clearUser(state) {
      state.username = null;
      state.email = null;
    },
  },
});

export const userActions = userSlice.actions;
export const userReducer = userSlice.reducer;

export const selectUser = (state: RootState) => state.user;
export const selectUsername = (state: RootState) => state.user.username;
export const selectUserEmail = (state: RootState) => state.user.email;

export const userSelectors = {
  selectUser,
  selectUsername,
  selectUserEmail,
};

export const { setUser, clearUser } = userActions;